export default __webpack_public_path__ + "static/media/home_pic3.520858d6.png";